// extracted by mini-css-extract-plugin
export default {"teamLogo":"ShareButton_teamLogo__EWpDN","headerTitle":"ShareButton_headerTitle__LOmFv","shareMessage":"ShareButton_shareMessage__z8LZq"};